<template>
    <div :class="[
        'input-number-multiple',
        themeClass,
        { 'is-error': isError }
    ]">
        <label v-text="label" />
        <div class="input-number-multiple-inputs flex flex-space-4">
            <input 
                v-for="(length, i) in itemsLengths" 
                v-model="values[i]"
                :key="i" 
                :maxlength="length"
                :style="{ width: Math.round(100 * length / totalLengths) + '%' }"
                @input="onInput" 
                @keyup="isError = false"
            />
        </div>
    </div>
</template>

<script>
import ThemeClassMixin from '@/mixins/ThemeClassMixin'
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ThemeClassMixin,
        ValidateMixin
    ],

    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        itemsLengths: {
            type: Array,
            required: true
        }
    },

    data () {
        return {
            themeClassPrefix: 'input-number-multiple--',
            values: []
        }
    },

    computed: {
        totalLengths() {
            return this.itemsLengths.reduce((a, b) => a + b, 0)
        },

        value() {
            return this.values.join('')
        }
    },

    methods: {
        onInput(e) {
            const targetElement = e.target
            const nextSiblingElement = targetElement.nextSibling

            if (nextSiblingElement && targetElement.value.length >= parseInt(targetElement.getAttribute('maxlength'))) {
                nextSiblingElement.focus()
            }

            this.$emit('input', this.values)
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired(),
                this.validateAgainstMinLength(9),
                this.validateAgainstNumberRegex()
            ]
        }
    }
}
</script>

<style lang="scss">
.input-number-multiple {
    @include input();

    &--compact {
        display: flex;
        align-items: end;

        > label {
            font-weight: $font-weight-bold;
            position: relative;
            padding-right: 55px;
            padding-bottom: 2px;
            top: -5px;
            font-size: 2.0rem;
            line-height: 2.8rem;
        }

        .input-number-multiple-inputs {
            max-width: 63%;
        }
    }
}
</style>
